import React from 'react';
import { useHistory } from 'react-router-dom';
import { version } from '../../../package.json';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import LogoGrey from '../../assets/images/logo-grey.png';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  grow: {
    flexGrow: 1,
  },
  textContainer: {
    width: 300,
  },
  text: {
    color: '#8b8b8b',
    textAlign: 'center',
  },
  link: {
    color: '#8b8b8b',
    textAlign: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  logoContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 140,
    height: 50,
  },
  email: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(4),
    color: '#757575',
  },
  toolbar: {
    height: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
  },
  homeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
  },
  arrowIcon: {
    fontSize: 45,
    cursor: 'pointer',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    paddingLeft: 12,
  },
  version: {
    marginTop: theme.spacing(10),
    color: '#8b8b8b',
    textAlign: 'center',
  },
}));

export default function AboutScreen() {
  const history = useHistory();
  const classes = useStyles();

  return (
    <>
      <div className={classes.toolbar}>
        <div className={classes.homeContainer}>
          <ArrowBackIosIcon
            className={classes.arrowIcon}
            onClick={() => {
              history.goBack();
            }}
          />
          <Typography variant="h4" className={classes.title}>
            About
          </Typography>
        </div>
      </div>
      <div className={classes.container}>
        <Grid item xs={12}>
          <div className={classes.logoContainer}>
            <img src={LogoGrey} className={classes.logo} alt="profile" />
          </div>
          <div className={classes.textContainer}>
            <Typography variant="body2" className={classes.text} gutterBottom>
              Your program has been provided by Flex Rewards, a software
              engineering company dedicated to providing the best loyalty
              solutions for businesses.
            </Typography>
            <Typography variant="body2" className={classes.link} gutterBottom>
              Find out more about Flex Rewards on our official website at
              <br />
              <Link href={'https://myflexrewards.com'} target="blank">
                www.myflexrewards.com
              </Link>
            </Typography>
            <Typography variant="body2" className={classes.link} gutterBottom>
              Click to read our&nbsp;
              <Link href={'https://myflexrewards.com/terms/'} target="blank">
                Terms of Service
              </Link>{' '}
              &nbsp;and&nbsp;
              <Link href={'https://myflexrewards.com/privacy/'} target="blank">
                Privacy Policy
              </Link>
            </Typography>
            <Typography variant="body2" className={classes.link} gutterBottom>
              For support&nbsp;
              <Link href={'mailto:customerservice@myflexrewards.com'}>
                contact us.
              </Link>
            </Typography>
            <Typography
              variant="body2"
              className={classes.version}
              gutterBottom
            >
              Version {version}
            </Typography>
          </div>
        </Grid>
      </div>
    </>
  );
}
